import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './IntraOne.frontend.types'

@Injectable({ providedIn: 'root' })
export class IntraOne_generate_data_1310_by_shipping_container_idService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { shipping_container_id: number, is_hold?: boolean, mode: string }): Promise<{ result?: any }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.shipping_container_id)) {
      $missingRequiredInParams.push('\'shipping_container_id\'');
    }
    if (isNil($inParams.mode)) {
      $missingRequiredInParams.push('\'mode\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/IntraOne/functions/generate_data_1310_by_shipping_container_id`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

